// Community transports shared by web and mobile. Every route here is part of
// the typed RPC surface (communityRoutes is mounted inside buildRpcRouter), so
// all calls go through the Hono client; admin-only community routes live under
// /api/admin/community outside AppType and stay in the web client.
import { jsonOrThrow, withSignal } from "./api.js";
export async function fetchCommunity(client, query = {}, signal) {
    const res = await client.api.community.$get({ query }, withSignal(signal));
    return jsonOrThrow(res, "GET /api/community");
}
export async function fetchWeeklyRecipe(client) {
    const res = await client.api.community["weekly-recipe"].$get();
    return jsonOrThrow(res, "GET /api/community/weekly-recipe");
}
export async function fetchCommunityMeStats(client) {
    const res = await client.api.community.me.stats.$get();
    return jsonOrThrow(res, "GET /api/community/me/stats");
}
export async function fetchCommunityTeammates(client, query = "") {
    const res = await client.api.community.teammates.$get({
        query: { q: query, limit: "48" },
    });
    return jsonOrThrow(res, "GET /api/community/teammates");
}
export async function fetchCommunityMemberProfile(client, userId, signal) {
    const res = await client.api.community.profiles[":userId"].$get({ param: { userId } }, withSignal(signal));
    return jsonOrThrow(res, "GET /api/community/profiles/:userId");
}
export async function createCommunityMoment(client, input) {
    const res = await client.api.community.moments.$post({ json: input });
    return jsonOrThrow(res, "POST /api/community/moments");
}
export async function removeCommunityMoment(client, id) {
    const res = await client.api.community.moments[":id"].$delete({ param: { id } });
    return jsonOrThrow(res, "DELETE /api/community/moments/:id");
}
export async function sendCommunityKudos(client, input) {
    const res = await client.api.community.kudos.$post({ json: input });
    return jsonOrThrow(res, "POST /api/community/kudos");
}
export async function reactToCommunityItem(client, input) {
    const res = await client.api.community.reactions.$post({ json: input });
    return jsonOrThrow(res, "POST /api/community/reactions");
}
export async function fetchCommunityItemReactors(client, query) {
    const res = await client.api.community.reactions.$get({ query });
    return jsonOrThrow(res, "GET /api/community/reactions");
}
export async function reportCommunityItem(client, input) {
    const res = await client.api.community.reports.$post({ json: input });
    return jsonOrThrow(res, "POST /api/community/reports");
}
export async function updateCommunityPreferences(client, input) {
    const res = await client.api.community.preferences.$put({ json: input });
    return jsonOrThrow(res, "PUT /api/community/preferences");
}
export async function seedCommunityDemo(client) {
    const res = await client.api.community["dev-seed"].$post();
    return jsonOrThrow(res, "POST /api/community/dev-seed");
}
export async function uploadCommunityAsset(client, input) {
    const res = await client.api.community.assets.$post({ json: input });
    return jsonOrThrow(res, "POST /api/community/assets");
}
export async function uploadProfileImage(client, input) {
    const res = await client.api.community["profile-image"].$post({ json: input });
    return jsonOrThrow(res, "POST /api/community/profile-image");
}
export async function removeProfileImage(client) {
    const res = await client.api.community["profile-image"].$delete();
    return jsonOrThrow(res, "DELETE /api/community/profile-image");
}
/** Share a piece of plan content (recipe/article/story/role model/reset) with
 *  teammates or the company wall. */
export async function shareContent(client, input) {
    const res = await client.api.community["share-content"].$post({ json: input });
    return jsonOrThrow(res, "POST /api/community/share-content");
}
//# sourceMappingURL=community.js.map